import React, { useCallback, useEffect, useRef, useState } from 'react';
import DataGrid, { Button, Column, Pager, Paging, Scrolling, Summary, TotalItem } from 'devextreme-react/data-grid';
import { Modal, Button as BsButton } from 'react-bootstrap';
import { GetStockReportDetailes } from '../services/StockReportAPI';
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { faFileExcel } from '@fortawesome/free-solid-svg-icons';
import ExcelImage from '../../../../../assets/images/excel.jpg';

interface ShowReportDetailModalProps {
    selectedId: string;
    materialType: string;
    StockType: number;
    handleClose(): void;
    status?: string;
}

const ShowReportDetailModal: React.FC<ShowReportDetailModalProps> = ({
    selectedId,
    materialType,
    StockType,
    handleClose,
    status = ''
}) => {
    const [gridData, setGridData] = useState<any[]>([]);

    const isMainStore = localStorage.getItem('mayavePurityEdit') !== 'false';
    const [productHeaderList, setProductHeaderList] = useState<any[]>([]);


    useEffect(() => {
        const loadData = async () => {
            try {
                const response = await GetStockReportDetailes({
                    id: selectedId,
                    materialType,
                    StockType,
                });
                setProductHeaderList(response.data || [])

                const data = Array.isArray(response) ? response : response.data || [];
                setGridData(data);
            } catch (error) {
                console.error('Error loading stock detail data:', error);
                setGridData([]);
            }
        };

        if (selectedId) {
            loadData();
        }
    }, [selectedId, materialType, StockType]);

    const renderSerialNumber = useCallback((cellData: any) => {
        const rowIndex = cellData.rowIndex + 1 + cellData.component.pageIndex() * cellData.component.pageSize();
        return <span>{rowIndex}</span>;
    }, []);

    const handleSubmit = () => {
        console.log("Submit clicked");
    };


    const handleExportExcel = () => {
        if (!productHeaderList || productHeaderList.length === 0) return;

        const worksheet = XLSX.utils.json_to_sheet(productHeaderList);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "StockReportDetails");

        const excelBuffer = XLSX.write(workbook, {
            bookType: "xlsx",
            type: "array",
        });

        const blob = new Blob([excelBuffer], {
            type: "application/octet-stream",
        });

        saveAs(blob, "Stock_Report_Details.xlsx");
    };


    return (
        <Modal show onHide={handleClose} size="xl" backdrop="static" centered>
            <Modal.Header closeButton>
                <Modal.Title>Stock Report Details</Modal.Title>

            </Modal.Header>

            <div className='d-flex align-content-center justify-content-end' style={{marginRight:'20px'}}>
                <button
                    onClick={handleExportExcel}
                    className="btn btn-sm ms-3 mt-2"
                    title='Export to Excel'
                >
                    <img
                        title='Export to Excel'
                        src={ExcelImage}
                        width={25}
                    />
                </button>

            </div>
            <Modal.Body>

                <DataGrid
                    dataSource={gridData}
                    keyExpr="id"
                    showBorders={true}
                    columnAutoWidth={true}
                    className='text-center'
                    onCellPrepared={(e) => {
                        if (['data', 'header'].includes(e.rowType)) {
                            e.cellElement.style.textAlign = 'center';
                        }
                    }}
                >
                    <Scrolling
                        mode="standard"
                        useNative={true}
                        scrollByContent={true}
                        scrollByThumb={true}
                    />
                    <Pager
                        visible={true}
                        showPageSizeSelector={true}
                        allowedPageSizes={[10, 25, 50, 100]}
                        showNavigationButtons={true}
                        displayMode="full"
                        showInfo={true}
                    />
                    <Summary>
                        <TotalItem
                        // column="Sr.No."
                        // summaryType="count"
                        // displayFormat="Total : {0}"
                        />
                    </Summary>
                    <Paging defaultPageSize={10} />

                    <Column
                        caption="Sr.No."
                        dataType="number"
                        alignment="center"
                        cellRender={renderSerialNumber}
                    />
                    <Column dataField="state" caption="State" dataType="string" />
                    <Column dataField="city" caption="City" dataType="string" />
                    <Column dataField="site" caption="Site" dataType="string" />
                    <Column dataField="storeName" caption="Store Name" dataType="string" />
                    <Column dataField="storeCode" caption="Store Code" dataType="string" />
                    <Column dataField="materialType" caption="Material Type" dataType="string" />
                    {/* <Column dataField="inwardDate" caption="Inward Date" dataType="date" /> */}
                    <Column dataField="invoiceDate" defaultSortOrder="desc" caption="Invoice Date" dataType="date" />
                    <Column dataField="category" caption="Category" dataType="string" />
                    <Column dataField="metalKt" caption="Metal KT" dataType="string" />
                    {/* <Column dataField="size" caption="Size" dataType="string" /> */}
                    {/* <Column dataField="colourCode" caption="Colour Code" dataType="string" /> */}
                    <Column dataField="grossWt" caption="Gross Wt" dataType="number" format="#,##0.000" />
                    <Column dataField="netWt" caption="Net Wt" dataType="string" format="#,##0.000" />
                    <Column dataField="pcs" caption="Quantity" dataType="string" />
                    <Column dataField="bagNo" caption="BagNo." dataType="string" />
                    <Column dataField="styleNo" caption="Style No" dataType="string" />
                    <Column dataField="remark" caption="Remark" dataType="string" />
                    <Column dataField="collectionName" caption="Collection Name" dataType="string" />
                    <Column dataField="diaPcs" caption="Dia qty" dataType="string" />
                    <Column dataField="diaWt" caption="Dia Wt" dataType="string" format="#,##0.000" />
                    <Column dataField="purchaseRate" format="#,##0.00" caption="Purchase Rate" dataType="number" />
                    <Column dataField="totalCostAmt" format="#,##0.00" caption="Total Cost Amt" dataType="number" />
                    <Column dataField="todaysGoldRate" format="#,##0.00" caption="Today Gold Rate" dataType="number" />
                    <Column dataField="complexityName" caption="Complexity" dataType="string" />
                    <Column dataField="huid" caption="HUID" dataType="string" />
                    <Column dataField="igiNo" caption="IGI No" dataType="string" />



                </DataGrid>

            </Modal.Body>

        </Modal >
    );
};

export default ShowReportDetailModal;
